var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPurls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2934 13.6395C36.1551 18.4587 34.927 24.5858 30.4085 28.0072C35.5487 29.731 41.1562 27.0853 42.9327 22.0975C43.8673 19.478 43.5815 16.5925 42.1526 14.1941C37.6226 6.57555 27.5855 3.95983 19.7342 8.35558C19.7304 8.35933 19.7265 8.35933 19.7227 8.36308L19.8578 8.58793C25.0019 7.00276 30.5939 9.10507 33.2934 13.6395Z",
    fill: "#00C8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.85 30.8257C27.1934 30.822 22.3982 26.7769 21.613 21.3367C17.5687 24.7637 17.1495 30.7294 20.6791 34.656C22.5202 36.7063 25.1846 37.8832 27.9862 37.8906C36.9361 37.8906 44.1937 30.8442 44.1937 22.1546H43.9268C42.7909 27.2136 38.1826 30.822 32.85 30.8257Z",
    fill: "#00A2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8703 21.6495C20.7001 16.8151 26.7105 14.7777 31.9582 16.8715C30.94 11.6726 25.8334 8.2705 20.559 9.27797C17.7902 9.80426 15.3913 11.4921 13.9803 13.898C9.50292 21.5442 12.1611 31.3181 19.9183 35.7314L20.0517 35.5059C16.1121 31.9647 15.2045 26.2019 17.8703 21.6495Z",
    fill: "#0079DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9996 49.4063C30.5833 49.4063 32.6778 47.1506 32.6778 44.3681C32.6778 41.5856 30.5833 39.33 27.9996 39.33C25.4158 39.33 23.3213 41.5856 23.3213 44.3681C23.3213 47.1506 25.4158 49.4063 27.9996 49.4063Z",
    fill: "#00A2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4332 15.5788C50.0169 15.5788 52.1114 13.4842 52.1114 10.9005C52.1114 8.31676 50.0169 6.22223 47.4332 6.22223C44.8494 6.22223 42.7549 8.31676 42.7549 10.9005C42.7549 13.4842 44.8494 15.5788 47.4332 15.5788Z",
    fill: "#00C8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56695 15.5788C11.1507 15.5788 13.2452 13.4842 13.2452 10.9005C13.2452 8.31676 11.1507 6.22223 8.56695 6.22223C5.98321 6.22223 3.88867 8.31676 3.88867 10.9005C3.88867 13.4842 5.98321 15.5788 8.56695 15.5788Z",
    fill: "#0079DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPurls);
export default __webpack_public_path__ + "static/media/logo-purls.57bdc9e4be7a20fd4d21b9818414baf9.svg";
export { ForwardRef as ReactComponent };